import { ApiClient } from '@/services/api/client'
import { callWithAuth } from '@/services/auth/call-with-auth'
import { LoadSessionData } from '@/services/session/load-session-data'
import { log } from '@/util/log'

const target = '/api/hl-proxy/product-views'

/**
 * セッションデータ(ユーザー情報)が充足した状態を保証する。充足できなければ reject する
 */
type EnsureSessionDataIsFulfilled = () => Promise<unknown>

/**
 * GP web での商品詳細の閲覧をホテラバアプリBFF に記録する front API のクライアント。
 * front 側の API はホテラバ(hl2)でのみルートが存在する。
 */
export class ProductViewRecordService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClient,
    private readonly ensureSessionDataIsFulfilled: EnsureSessionDataIsFulfilled =
      () => LoadSessionData.getInstance().load()
  ) {}

  /**
   * 記録の失敗(タイムアウト・4xx・5xx 等)は呼び出し元へ伝播させない(reject しない)。
   * 記録は計測目的で、失敗しても商品詳細の表示・操作に影響させないため。
   */
  async record(gpFkuId: string): Promise<void> {
    try {
      /**
       * この API は閲覧ユーザーを client から受け取らずセッション cookie から解決する。
       * cookie にユーザー情報が載るのはセッションデータが充足した後なので、待たずに送ると
       * 記録されない。サーバは前提不成立でも 204 を返すため、呼び出し側では失敗を観測できない。
       */
      await this.ensureSessionDataIsFulfilled()

      await callWithAuth(() => this.apiClient.postJson(target, { gpFkuId }))
      log.debug({ service: target, gpFkuId })
    } catch (error) {
      log.error({ service: target, gpFkuId, error })
    }
  }
}
